const STORAGE_KEY = 'chunk-reload-attempted';

// sessionStorage throws SecurityError in iOS Safari private browsing
function safeSessionStorage(): Pick<Storage, 'getItem' | 'setItem'> {
  try {
    sessionStorage.getItem('');
    return sessionStorage;
  } catch {
    return { getItem: () => null, setItem: () => {} };
  }
}

export function registerChunkReloadHandler(
  win: Window = window,
  storage: Pick<Storage, 'getItem' | 'setItem'> = safeSessionStorage(),
): void {
  win.addEventListener('vite:preloadError', () => {
    if (storage.getItem(STORAGE_KEY)) return;
    storage.setItem(STORAGE_KEY, '1');
    win.location.reload();
  });
}
